<template>
  <div class="evaluate-list">
    <titleHeader title="商品评价"></titleHeader>
    <van-list
      class="list-box"
      v-model="display.loading"
      :finished="finished"
      finished-text="没有更多了"
      :immediate-check="false"
      @load="loadEvaluate"
    >
      <div></div>
      <goodsEvaluation :evaluate-list="evaluateList"></goodsEvaluation>
    </van-list>
  </div>
</template>

<script>
  import api from 'api/goods-list';
  import goodsEvaluation from 'components/goods-evaluation';
  export default {
    components: {
      goodsEvaluation
    },
    data(){
      return {
        evaluateList: [],
        page: {
          pageSize: 5,
          pageNumber: 1
        },
        display: {
          loading :false
        },
        finished: false,//已加载全部
      }
    },
    created() {
      this.getEvaluation()
    },
    methods:{
      //获取评论
      async getEvaluation() {
        const data = await api.getEvaluateByGoodsId({
          goodsId: this.$route.query.goodsId,
          pageNumber: this.page.pageNumber,
          pageSize: this.page.pageSize
        })
        this.display.loading = false;
        if (data.records.length < this.page.pageSize) {
          this.finished = true;
        }
        //排序
        this.evaluateList = this.evaluateList.concat(data.records);
        console.log(data);
      },
      //上拉加载
      loadEvaluate(){
        this.page.pageNumber ++;
        this.getEvaluation()
      },
    },
    filters:{
      formatTime(val) {
        if (val.indexOf(' ') > -1) {
          return val.split(' ')[0];
        }else{
          return val
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  @import 'common/sass/theme';
  .evaluate-list{
    .list-box{
      height: calc(100vh - #{$top-nav-height});
      overflow: auto;
    }
  }
</style>